<template>
        <select class="form-control" :class="{'error-empty-field':isEmpty}" v-model="selectValue">
            <option :value="null"></option>
            <option v-for="(o, key) in options" :value="o.value" :key="key">{{o.name}}</option>
        </select>
</template>
<script>
export default {
  props: ["value", "options"],

  computed: {
      selectValue: {
          get: function() {
              return this.value
          },
          set: function(value) {
            this.$emit("saveEdit", value);
          }
      },
      isEmpty: function() {
        return this.value ? false : true
      }
  }
};
</script>

<style scoped>
.error-empty-field {
  background-color: #FFCCD9;
}
</style>
